// icons.ts
import { FileText, Home, User, Settings, Search, Handshake, BookUser, CircleHelp, ChevronLeft, CircleAlert, Plus, X, ArrowLeft, ChevronRight, Pencil, Trash2, FileUser, Check, Calendar, Mail, Navigation, Minus, Eye, Fullscreen, CornerDownRight, ArrowUpDown, LayoutDashboard, ClipboardList, NotepadText, ShieldAlert, Target, ClipboardCheck, CirclePlus, History, CircleCheckBig, FileCheck, Users, SearchCheck, Send, Download, BookA } from 'lucide-angular';

export const Icons = {
    FileText,
    Home,
    User,
    Settings,
    Search,
    Handshake,
    BookUser,
    CircleHelp,
    ChevronLeft,
    ChevronRight,
    CircleAlert,
    CirclePlus,
    Plus,
    X,
    ArrowLeft,
    Pencil,
    Trash2,
    FileUser,
    Check,
    Calendar,
    Mail,
    Navigation,
    Minus,
    Eye,
    Fullscreen,
    CornerDownRight,
    ArrowUpDown,
    LayoutDashboard,
    ClipboardList,
    NotepadText,
    ShieldAlert,
    Target,
    ClipboardCheck,
    History,
    CircleCheckBig,
    FileCheck,
    Users,
    SearchCheck,
    Send,
    Download,
    BookA
} as const;
